import { ISensor } from 'app/shared/model/sensor.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IStatisticMarkLine {
  id?: number;
  value?: number | null;
  label?: string | null;
  lineType?: string | null;
  color?: string | null;
  sensor?: ISensor | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IStatisticMarkLine> = {};
